/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  /**
   * Модель запроса данных с DaData
   */
  app.RequestData = app.Model.extend({
    requestOptions: {
      headers: {Authorization: 'Token ' + app.DADATA_TOKEN},
    },
    url: function () {
      return 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/party';
    },
    run: function () {
      this.set({
        'count': 20,
        'restrict_value': true,
        'from_bound': {'value': 'party'},
        'to_bound': {'value': 'party'},
        'locations': [{}]}
      );
    },
    /**
     * Получает опции и сохраняет в модель
     * @param {string} query Запрашиваемая строка
     */
    getSuggestions: function (query) {
      if (query && typeof query === 'string') {
        this.save({query: query}, this.requestOptions);
      }
    },
  });
})();


}.call(window));